export default __webpack_public_path__ + "static/media/soesvinget-property-17.b764c35c.jpg";